/**
 * Pages
 */

export * from './pages/SupplierOrderDetail/SupplierOrderDetail';
export * from './pages/SupplierOrders/SupplierOrders';
